import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPolicyBySlug } from "../services/policyService";

export const fetchPolicy = createAsyncThunk(
    "policy/fetch",
    async (slug, { rejectWithValue }) => {
        try {
            return await getPolicyBySlug(slug);
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || error.message || "Failed to fetch policy"
            );
        }
    }
);

const initialState = {
    data: null,
    loading: false,
    error: null,
};

const policySlice = createSlice({
    name: "policy",
    initialState,
    reducers: {
        resetPolicy: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPolicy.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPolicy.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchPolicy.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetPolicy } = policySlice.actions;
export default policySlice.reducer;
